export const FrontPageContentFi = () => {
  return (
    <>
      <h3>Tietoa sivustosta</h3>
      <p>
        Tällä sivustolla esitetään Suomea koskevia tietoja teollisuuslaitosten
        ja maatalousyritysten päästöistä ilmaan ja veteen, sekä tietoja
        jätteiden siirroista. Tiedot haetaan Euroopan ympäristökeskuksen
        (European Environment Agency, EEA) kokoamasta ja ylläpitämästä
        PRTR-rekisteristä, jonka tarkoituksena on lisätä yleisön tietoisuutta
        ympäristökuormituksesta, sekä edistää teollisuuden pyrkimyksiä
        ympäristönsuojelulle asetettujen tavoitteiden ja kansainvälisten
        sopimusten velvoitteiden saavuttamisessa.
      </p>
      <p>
        Toiminnanharjoittajat ovat velvollisia ilmoittamaan ympäristölle
        vaarallisten toimintojensa päästö- ja jätetietoja EU-asetuksen 166/2006
        mukaisesti. Laitoksen on ilmoitettava päästöt, jos sen toiminnalle tai
        yhdistekohtaisille päästöille asetetut kynnysarvot ylittyvät. Tiedot
        kootaan Euroopan{' '}
        <a
          href="https://www.eea.europa.eu/data-and-maps/data/industrial-reporting-under-the-industrial-3"
          target="blank">
          PRTR-rekisteriin
        </a>{' '}
        (Pollutant Release and Transfer Register). Muita kuin PRTR-raportointiin
        kuuluvia päästölähteitä ei palvelussa esitetä. Tällä hetkellä tietoa
        esitetään raportointivuodesta 2017 eteenpäin. 
      </p>
      <h3>Hakuvaihtoehdot</h3>
      <p>Voit selata rekisteriin tallennettuja tietoja seuraavin toiminnoin:</p>
      <p>
        <li>
          <b>Laitoshaun</b> avulla voit selata PRTR-rekisteriin tallennettuja
          tietoja toimialoittain, paikkakunnan tai laitoksen nimen perusteella. 
        </li>
        <li>
          <b>Päästöt ilmaan</b> näyttää päästötietojaan raportoineiden
          PRTR-laitosten päästötietoja ilmaan taulukkomuodossa. 
        </li>
        <li>
          <b>Päästöt veteen</b> erottelee päästötietokannasta veteen kohdistuvat
          päästöt. 
        </li>
        <li>
          <b>Jätesiirrot</b> hakee tietoja kotimaan sisällä ja rajojen yli
          suoritetuista jätesiirroista 
        </li>
      </p>
      <p>
        Ennen käyttöä, luethan palvelun{' '}
        <a href="Käyttöehdot.pdf" target="blank">
          käyttöehdot
        </a>
        .
      </p>

      <p>
        Suomen ympäristökeskus on toteuttanut sivuston ympäristöministeriön
        toimeksiannosta. Palautetta päästötiedoista ja muista sisältöä
        koskevista asioista voi lähettää valvontaviranomaisille (
        <a href="https://lvv.fi/ymparisto/" target="blank">
          Lupa- ja valvontavirasto
        </a>
        ). Sivuston teknisestä toiminnasta voi lähettää palautetta tai
        kehitysehdotuksia osoitteeseen{' '}
        <a href="mailto:PRTR@syke.fi">PRTR@syke.fi</a>.
      </p>

      <p>
        <a href="Palveluseloste.pdf" target="blank">
          Palveluseloste
        </a>
      </p>
    </>
  )
}
